import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import activeHtml from 'react-active-html'
import { filterPropName } from '../helper/object'

import './calendar.css'

const toLocalDate = dateString => new Date(dateString).toLocaleDateString('de-DE')

export const DateTime = ({date: {start_date, time, show_end_date, end_date}}) =>
	<div className="date">
		<span>{toLocalDate(start_date)}</span>
		{show_end_date
			? <span>{toLocalDate(end_date)}</span>
			: <span className="time">{time}</span>}
	</div>

DateTime.propTypes = {
	date: PropTypes.exact({
		start_date: PropTypes.string.isRequired,
		time: PropTypes.string,
		show_end_date: PropTypes.bool.isRequired,
		end_date: PropTypes.string,
	}).isRequired,
}

const mapEntryToDate = entry =>
	filterPropName(entry, ['start_date', 'time', 'show_end_date', 'end_date'])

const componentsMap = {}

export const Calendar = ({entries, future}) =>
	<div className={future ? 'calendar' : 'calendar past'}>
		{entries.map((entry, index) => <div key={index}>
			<DateTime date={mapEntryToDate(entry)} />
			<h1>{entry.Title}</h1>
			{activeHtml(entry.Content, componentsMap)}
		</div>)}
	</div>

Calendar.propTypes = {
	entries: PropTypes.array.isRequired,
	future: PropTypes.bool,
}

const endsAfter = now => entry =>
	new Date(entry.start_date) > new Date(now()) - 24*60*60*1000
	|| (entry.show_end_date
		&& new Date(entry.end_date) > new Date(now()) - 24*60*60*1000)

const endsBefore = now => entry => !endsAfter(now)(entry)

const isAfter = (a, b) => a.start_date > b.start_date ? 1 : -1
const isBefore = (a, b) => a.start_date < b.start_date ? 1 : -1

// TODO: multiple path??
export const mapStateToProps = now => ({calendar}, {className}) => {
	if(className === 'future'){
		return {
			entries: calendar
				.filter(endsAfter(now))
				.sort(isAfter),
			future: true,
		}
	}else{
		return {
			entries: calendar
				.filter(endsBefore(now))
				.sort(isBefore),
			future: false,
		}
	}
}

export default connect(
	mapStateToProps(() => new Date().toISOString())
)(Calendar)



// WEBPACK FOOTER //
// ./src/components/calendar.jsx